export const enum ProductSearchType {
  Accommodation = 'accommodation',
  Activity = 'activity',
}
